module.exports = __webpack_public_path__ + "img/1 (105).58d82f8e.png";